import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthInterceptor } from 'app/fuse-template/core/auth/auth.interceptor';
import { AuthService } from 'app/fuse-template/core/auth/auth.service';

@NgModule({
    imports: [],
    providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AuthModule {}
